import * as R from "ramda";

import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { bindInstance } from "redux-mvc";

import Status from "ui-kit/TaskStatus";
import Tooltip from "ui-kit/Tooltip";

import { getValue } from "../../utils";
import { actions } from "../../model";

import AlertPopoverComponent from "../Utils/AlertPopOver";
import { ROW_ACTIONS } from "../../constants";
import { canAssignTask } from "../../selectors";
import { Text1, Div } from "components/Base";
import { noop } from "utils/General";
const decorate = connect(
  state => ({
    canAssignTask: canAssignTask(state)
  }),
  bindInstance({
    executeAction: actions.executeAction
  })
);

const ApplicationForm = props => {
  let status = getValue(props, "status", "");
  const taskId = R.pathOr(null, ["field", "id"], props);
  const type = R.pathOr(null, ["field", "type"], props);
  const rowId = R.pathOr(null, ["data", "id"], props);

  const instanceId = R.pathOr(null, ["instanceId"], props);
  const isDashboard = instanceId === "dashboard";

  const statusMap = {
    "not-submitted": {
      status: "not-submitted",
      tooltip: "Not Submitted"
    },
    "manual-not-submitted": {
      status: "manual-not-submitted",
      tooltip: "Manually Assigned"
    },
    pending: {
      status: "pending",
      tooltip: "Pending Approval"
    },
    approved: {
      status: "approved",
      tooltip: "Approved"
    },
    rejected: {
      status: "rejected",
      tooltip: "Rejected"
    },
    default: {
      status: "not-submitted",
      tooltip: "Not Submitted"
    }
  };

  const oldStatusMap = {
    "not-submitted": {
      status: "not-submitted",
      tooltip: "Not Submitted"
    },
    "manual-not-submitted": {
      status: "manual-not-submitted",
      tooltip: "Manually Assigned"
    },
    pending: {
      status: "pending",
      tooltip: "Pending Approval"
    },
    approved: {
      status: "approved",
      tooltip: "Approved"
    },
    rejected: {
      status: "rejected",
      tooltip: "Rejected"
    },
    default: {
      status: "not-submitted",
      tooltip: "Not Submitted"
    }
  };

  const [showPopover, setShowPopover] = useState(false);

  const realStatus = isDashboard
    ? R.pathOr(statusMap.default.status, [status, "status"], statusMap)
    : R.pathOr(oldStatusMap.default.status, [status, "status"], oldStatusMap);

  const onConfirm = e => {
    e.stopPropagation();
    e.preventDefault();
    setShowPopover(false);
    R.propOr(noop, realStatus, {
      "not-assigned": () => {
        props.executeAction({
          actionId: ROW_ACTIONS.ASSIGN_TASK,
          data: { taskId, type, rowId }
        });
      },
      "manual-not-submitted": () => {
        props.executeAction({
          actionId: ROW_ACTIONS.REMOVE_ASSIGNMENT_TASK,
          data: { taskId, type, rowId }
        });
      }
    })();
  };

  const onRequestClose = e => {
    e.stopPropagation();
    e.preventDefault();
    setShowPopover(false);
  };

  const handleClick = e => {
    if (props.canAssignTask) {
      e.stopPropagation();
      e.preventDefault();
      if (R.contains(realStatus, ["not-assigned", "manual-not-submitted"])) {
        setShowPopover(true);
      }
    }
  };

  const anchor = useRef(null);

  const tooltipText = isDashboard
    ? R.pathOr(statusMap.default.tooltip, [status, "tooltip"], statusMap)
    : R.pathOr(oldStatusMap.default.tooltip, [status, "tooltip"], oldStatusMap);

  const TooltipContent = () => {
    return (
      <Div display="column.flex-start.flex-start" p={2}>
        <Text1 color="white" bold>
          {tooltipText}
        </Text1>
        {realStatus === "not-assigned" && isDashboard && (
          <Text1 color="white"> Click to assign task.</Text1>
        )}
        {realStatus === "manual-not-submitted" && isDashboard && (
          <Text1 color="white"> Click to unassign task.</Text1>
        )}
        {realStatus === "not-submitted" && isDashboard && (
          <Text1 color="white"> Cannot be removed here.</Text1>
        )}
      </Div>
    );
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "100%",
        height: "100%",
        padding: 8,
        borderRadius: 4
      }}
      onClick={isDashboard ? handleClick : noop}
      ref={anchor}
    >
      <Tooltip tooltip={<TooltipContent />} placement="bottom">
        <span>
          <Status status={realStatus} />
        </span>
      </Tooltip>

      <AlertPopoverComponent
        onClose={onRequestClose}
        open={showPopover}
        onConfirm={onConfirm}
        title={
          realStatus === "not-assigned"
            ? "Are you sure you want to assign this task?"
            : "Are you sure you want to unassign this task?"
        }
        primaryActionLabel={
          realStatus === "not-assigned" ? "Assign" : "Unassign"
        }
        secondaryActionLabel="Cancel"
        anchorEl={anchor?.current || null}
      />
    </div>
  );
};

export default decorate(ApplicationForm);
